import { render, staticRenderFns } from "./inquirydocumentsadmin.vue?vue&type=template&id=100236b8&scoped=true&"
import script from "./inquirydocumentsadmin.vue?vue&type=script&lang=js&"
export * from "./inquirydocumentsadmin.vue?vue&type=script&lang=js&"
import style0 from "./inquirydocumentsadmin.vue?vue&type=style&index=0&id=100236b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100236b8",
  null
  
)

export default component.exports